import dynamic from 'next/dynamic';
import { EventSpacesProps } from './EventSpaces.types';

export const EventSpaces = dynamic<{ model: EventSpacesProps }>(() =>
  import('./EventSpaces').then(mod => mod.EventSpaces)
);
